import "../../pages/reports/gce-o.css";
import { ExamType } from "../../types/types";

interface SubjectData {
  code: string;
  name: string;
  student_count: string | number;
}

interface DISOALSubjectsTableProps {
  registrationData: {
    exam_registration?: {
      subject_categories?: Record<string, SubjectData[]>;
    } | null;
  } | null;
  selectedExamTypes: ExamType[];
}

const DISOALSubjectsTable: React.FC<DISOALSubjectsTableProps> = ({
  registrationData,
  selectedExamTypes,
}) => {
  const shouldRenderTables = selectedExamTypes.some((et) =>
    et.name.includes("DIS")
  ); // Use .some() instead of finding the exact one and checking

  if (!shouldRenderTables) return null;

  const AUDITORYDISALGEN =
    registrationData?.exam_registration?.subject_categories?.AUDITORYDISALGEN ||
    [];
  const AUDITORYDISOLGEN =
    registrationData?.exam_registration?.subject_categories?.AUDITORYDISOLGEN ||
    [];
  const VISUALDISALGEN =
    registrationData?.exam_registration?.subject_categories?.VISUALDISALGEN ||
    [];
  const VISUALDISOLGEN =
    registrationData?.exam_registration?.subject_categories?.VISUALDISOLGEN ||
    [];

  const subjectMap = new Map<
    string,
    {
      name: string;
      counts: {
        vdisol?: number;
        vdisal?: number;
        adisol?: number;
        adisal?: number;
      };
    }
  >();

  AUDITORYDISALGEN.forEach((s) => {
    if (!subjectMap.has(s.code))
      subjectMap.set(s.code, { name: s.name, counts: {} });
    subjectMap.get(s.code)!.counts.adisal = Number(s.student_count);
  });
  AUDITORYDISOLGEN.forEach((s) => {
    if (!subjectMap.has(s.code))
      subjectMap.set(s.code, { name: s.name, counts: {} });
    subjectMap.get(s.code)!.counts.adisol = Number(s.student_count);
  });
  VISUALDISALGEN.forEach((s) => {
    if (!subjectMap.has(s.code))
      subjectMap.set(s.code, { name: s.name, counts: {} });
    subjectMap.get(s.code)!.counts.vdisal = Number(s.student_count);
  });
  VISUALDISOLGEN.forEach((s) => {
    if (!subjectMap.has(s.code))
      subjectMap.set(s.code, { name: s.name, counts: {} });
    subjectMap.get(s.code)!.counts.vdisol = Number(s.student_count);
  });

  const allSubjects = Array.from(subjectMap.entries()).map(([code, data]) => ({
    code,
    name: data.name,
    counts: data.counts,
  }));

  return (
    <table className="gceo-subjects-table">
      <tbody>
        <tr>
          <th rowSpan={3}>S/N</th>
          <th colSpan={2} rowSpan={3}>
            SUBJECT
          </th>
          <th colSpan={4}>CATEGORY OF SPECIAL NEEDS</th>
        </tr>
        <tr>
          <th colSpan={2}>VISUAL IMPAIRMENT (Braille for TEXT)</th>
          <th colSpan={2}>AUDITORY IMPAIRMENT (Sign Language for AUDIO)</th>
        </tr>
        <tr>
          <th>DISOL General</th>
          <th>DISAL General</th>
          <th>DISOL General</th>
          <th>DISAL General</th>
        </tr>

        {allSubjects.map((subj, index) => (
          <tr key={subj.code}>
            <td>{index + 1}</td>
            <td colSpan={2}>
              {subj.code} {subj.name}
            </td>
            <td>{subj.counts.vdisol ?? "N/A"}</td>
            <td>{subj.counts.vdisal ?? "N/A"}</td>
            <td>{subj.counts.adisol ?? "N/A"}</td>
            <td>{subj.counts.adisal ?? "N/A"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DISOALSubjectsTable;
